import React from 'react';
import { withTheme } from '@draftbit/ui';
import { Image, Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import Images from '../config/Images';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const ScreenSizeWarningBlock = props => {
  const { theme } = props;
  const dimensions = useWindowDimensions();

  return (
    <View
      style={StyleSheet.applyWidth(
        {
          alignItems: 'center',
          backgroundColor: palettes.Brand.Background,
          flex: 1,
          gap: [
            { minWidth: Breakpoints.Tablet, value: 20 },
            { minWidth: Breakpoints.Mobile, value: 20 },
          ],
          justifyContent: 'center',
          padding: 30,
        },
        dimensions.width
      )}
    >
      <Image
        {...GlobalStyles.ImageStyles(theme)['Image'].props}
        resizeMode={'contain'}
        source={imageSource(Images['logo'])}
        style={StyleSheet.applyWidth(
          GlobalStyles.ImageStyles(theme)['Image'].style,
          dimensions.width
        )}
      />
      {/* Image 2 */}
      <Image
        {...GlobalStyles.ImageStyles(theme)['Image'].props}
        resizeMode={'contain'}
        source={imageSource(Images['logotext'])}
        style={StyleSheet.applyWidth(
          StyleSheet.compose(GlobalStyles.ImageStyles(theme)['Image'].style, {
            height: 20,
          }),
          dimensions.width
        )}
      />
      <Text
        accessible={true}
        selectable={false}
        {...GlobalStyles.TextStyles(theme)['Text'].props}
        style={StyleSheet.applyWidth(
          StyleSheet.compose(GlobalStyles.TextStyles(theme)['Text'].style, {
            color: palettes.Brand.White,
            fontFamily: 'OpenSans_600SemiBold',
            fontSize: { minWidth: Breakpoints.Tablet, value: 20 },
            textAlign: 'center',
          }),
          dimensions.width
        )}
      >
        {
          'Small Browser - Limited Functionality\nPlease resize your browser or switch to a device at least 1024px wide to use Cash PlanIt.'
        }
      </Text>
    </View>
  );
};

export default withTheme(ScreenSizeWarningBlock);
